import React from 'react';
import { useTranslation } from 'react-i18next';
import { type MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import { usePushSubscription } from '../../../../redux/pwa/hooks';
import { isPWA } from '../../../../utils/isPWA';
import SuffixText from '../_partials/SuffixText';

export function usePushSubscriptionItem(): MenuItem | false {
  const { isSubscribed, isBlocked, manage } = usePushSubscription();
  const { t } = useTranslation();

  // Only show the PWA menu item on if we're running in PWA mode
  if (!isPWA()) {
    return false;
  }

  return {
    label: t('siteHeader.userMenu.pwa.loggedIn.label'),
    suffix: (
      <SuffixText>
        {isBlocked
          ? t('siteHeader.userMenu.pwa.loggedIn.suffix.blocked')
          : isSubscribed
            ? t('siteHeader.userMenu.pwa.loggedIn.suffix.enabled')
            : t('siteHeader.userMenu.pwa.loggedIn.suffix.disabled')}
      </SuffixText>
    ),
    onClick: manage,
  };
}
